export const geofences = {
	en: {
		sidebar: {
			title: 'SEARCH AND FILTERED',
			searchbox: ['Search GeoFence', 'Search POI', 'Search Place'],
			buttons: ['LIST VIEW', 'REPORT'],
			options: ['Devices', 'IFTA']
		},
		titles: ['Geofence information', 'Notifications', 'Point of interest information', 'Import and export', 'Searching tool'],
		tabs: ['Geofences', 'Points of interest'],
		columns: ['Name', 'Latitude', 'Longitude'],
		form: {
			title: {
				label: 'Write the title',
				required: 'Required Geofence Name'
			},
			detail: {
				label: 'Add details',
			},
			days: {
				label: 'Select days',
				required: 'Field days required',
			},
			events: {
				label: 'Notify',
				entry: 'Entry',
				output: 'Exit'
			},
			autoassign: {
				label: 'Auto assign devices',
				placeholder: '',
				require: '',
				help: 'Enabling this option the configuration will apply to all your (current and future) devices.',
			},
			devices: {
				label: 'Assigned devices',
				placeholder: 'Devices',
				required: 'Select at least 1 vehicle',
			},
			name: {
				label: 'Enter full name',
				required: 'Field required: Username'
			},
			email: {
				label: 'Send notification to (email or cellphone)',
				error: 'Email or invalid number',
				required: 'Add at least 1 email or number'
			},
			poi: {
				label: 'Name of the point of interest',
				error: 'The name is required'
			},
			description: 'Details',
			buttons: {
				save: 'Save',
				change: 'Save changes',
				cancel: 'Cancel',
				export: 'Export',
				import: 'Import',
				delete: 'Delete',
				download_template: 'Download template',
				template: 'https://gstrackme.s3.amazonaws.com/uploads/v3/uploads/points_template_en.xlsx',
				question: {
					label: 'Are you sure?',
					yes: 'YES',
					no: 'NO'
				}
			},
			invalid: {
				number: 'invalid Number.',
				email: 'invalid Email.'
			}
		},
		notifications: {
			saved: 'Saved data',
			updated: 'Updated data',
			delete: 'Deleted data',
			errorImport: 'An invalid record was detected, the import has been canceled, please check the csv.',
			permissions: 'No permissions for this action',
			denied: 'Denied',
			label: 'Successfully',
			showHide: ['Visible Geofences', 'Hidden Geofences', 'Visible POIS', 'Hidden POIS'],
			crud: {
				pois: {
					saved: 'saved POI',
					updated: 'updated POI',
					deleted: 'deleted POI'
				},
				geofence: {
					saved: 'saved Geofence',
					updated: 'updated Geofence',
					deleted: 'deleted Geofence'
				}
			},
			general: 'Oooops... Something wasn\'t loaded it well. Please reload the page'
		},
		//Reporte de Geocerca e Histórico
		tables: {
			titles: ['LIST OF GEOFENCES AND DEVICES', 'REPORT'],
			subtitles: {
				device: 'Device',
				geofence: 'Geofence',
				inGeo: 'Entry to geofence',
				outGeo: 'Geofence exit',
				mileage: 'Traveled'
			},
			search: ['Select device', 'Search geofence'],
			button: 'SEARCH',
			pager: ['Page', ' of ', 'rows per page', 'elements'],
			errors: {
				geofence: 'Select at least a geofence',
				device: 'Select at least a device',
				date: 'Select a valid date'
			}
		},
		feedback: ['Circular Geofence', 'Polygonal Geofence', 'POI'],
		ifta: {
			title: 'IFTA Report',
			subtitles: {
				200: 'Attention',
				204: 'Send later',
				400: 'Error'
			},
			columns: ['Device', 'State', 'Engine Hours', 'Idle Hours', 'Odometer'],
			buttons: {
				search: 'Search',
				download: 'Download',
				print: 'Print',
				sure: 'Got it',
				cancel: 'Cancel',
				send: 'Send later'
			},
			forms: ['Select devices', 'Select month/year', 'Emails'],
			notifications: {
				200: 'The report could not be generated, please try again in a moment',
				204: 'This report may take a few minutes to generate and will be sent to the email on record for this user. Please add any additional emails that you’d want to receive the report.',
				400: 'There was an error or there is not enough information to generate for the report',
				send: 'The report will be sent to emails in a few minutes',
				gral: 'There some errors, please check the data',
			}
		},
		actions: ['Delete Selected Item', 'Show/Hide Labels', 'Show/Hide Geofences', 'Show/Hide POIS'],
		reports: {
			tabs: {
				geofence: 'Permanency Report',
				device: 'Entry/Output Report',
				realtime: 'Realtime',
				ifta: 'IFTA',
			},
			selects: {
				geofence: 'Geofence(s)',
				device: 'Device(s)',
				realtime: ''
			},
			columns: {
				device: [
					{
						label: 'Device',
						img: '',
						width: ''
					},
					{
						label: 'Geofence',
						img: '',
						width: '24%'
					},
					{
						label: 'Entry',
						img: 'geofences/geo-1.svg',
						width: '16%'
					},
					{
						label: 'Output',
						img: 'geofences/geo-2.svg',
						width: '16%'
					},
					{
						label: 'Duration',
						img: '',
						width: '12%'
					},
					{
						label: 'Traveled',
						img: '',
						width: '10%'
					},
				],
				geofence: [
					{
						label: 'Geofence',
						img: '',
						width: '24%'
					},
					{
						label: 'Devices',
						img: '',
						width: ''
					},
					{
						label: 'Engine Hours',
						img: '',
						width: '12%'
					},
					{
						label: 'Idle Hours',
						img: '',
						width: '12%'
					},
					{
						label: 'Odometer',
						img: '',
						width: '10%'
					},
				],
				realtime: [
					{
						label: 'Geofence',
						img: '',
						width: '50%'
					},
					{
						label: 'Devices',
						img: '',
						width: '50%'
					},
				]
			},
			nodata: {
				geofence: 'No devices',
				device: 'No geofences'
			},
			notes: {
				retroactive: 'Reports are not retroactive',
			},
		}
	},
	es: {
		sidebar: {
			title: 'BÚSQUEDA Y FILTRADO',
			searchbox: ['Buscar Geocerca', 'Buscar POI', 'Buscar lugar'],
			buttons: ['REPORTE', 'HISTÓRICO'],
			options: ['Dispositivos', 'IFTA']
		},
		titles: ['Información de la Geocerca', 'Notificaciones', 'Información del punto de interés', 'Importar y exportar', 'Herramienta de busqueda'],
		tabs: ['Geocercas', 'Puntos de interés'],
		columns: ['Nombre', 'Latitud', 'Longitud'],
		form: {
			title: {
				label: 'Escribe el título',
				required: 'Nombre de Geocerca obligatorio'
			},
			detail: {
				label: 'Añadir detalles',
			},
			days: {
				label: 'Seleccionar días',
				required: 'Campo días obligatorio',
			},
			events: {
				label: 'Notificar',
				entry: 'Entrada',
				output: 'Salida'
			},
			autoassign: {
				label: 'Auto asignar dispositivos',
				placeholder: '',
				require: '',
				help: 'Al activar esta opción, se añadirán automáticamente a esta geocerca todos los dispositivos asignados a su cuenta.',
			},
			devices: {
				label: 'Dispositivos asignados',
				placeholder: 'Dispositivos',
				required: 'Seleccione mínimo 1 vehículo',
			},
			name: {
				label: 'Ingresar nombre completo',
				required: 'Campo requerido: Nombre de usuario'
			},
			email: {
				label: 'Enviar notificación a (email)',
				error: 'Email o número inválido',
				required: 'Agregue mínimo 1 email o número'
			},
			poi: {
				label: 'Nombre del punto de interés',
				error: 'El nombre es obligatorio'
			},
			description: 'Descripción',
			buttons: {
				save: 'Guardar',
				change: 'Guardar cambios',
				cancel: 'Cancelar',
				export: 'Exportar',
				import: 'Importar',
				delete: 'Eliminar',
				download_template: 'Descargar plantilla',
				template: 'https://gstrackme.s3.amazonaws.com/uploads/v3/uploads/points_template_es.xlsx',
				question: {
					label: 'Estás seguro?',
					yes: 'SI',
					no: 'NO'
				}
			},
			invalid: {
				number: 'email invalido.',
				email: 'email invalido.'
			}
		},
		notifications: {
			saved: 'Datos guardados',
			updated: 'Datos actualizados',
			delete: 'Datos eliminados',
			errorImport: 'Se detecto un registro inválido, se ha cancelado la importación, favor de revisar el csv.',
			permissions: 'Sin permisos para esta acción',
			denied: 'Denegado',
			label: 'Éxito.',
			showHide: ['Geocercas Visibles', 'Geocercas Ocultas', 'POIS Visibles', 'POIS Ocultos'],
			crud: {
				pois: {
					saved: 'POI guardado correctamente.',
					updated: 'POI actualizado correctamente.',
					deleted: 'POI eliminado correctamente.'
				},
				geofence: {
					saved: 'Geocerca guardada correctamente.',
					updated: 'Geocerca actualizada correctamente.',
					deleted: 'Geocerca eliminada correctamente.'
				}
			},
			general: 'Vaya ... Algo no se cargó bien. Por favor recarga la página'
		},
		//Reporte de Geocerca e Histórico
		tables: {
			titles: ['REPORTE DE GEOCERCAS Y DISPOSITIVOS', 'HISTÓRICO'],
			subtitles: {
				device: 'Dispositivo',
				geofence: 'Geocerca',
				inGeo: 'Entrada de Geocerca',
				outGeo: 'Salida de Geocerca',
				mileage: 'Recorrido'
			},
			search: ['Elije un vehículo', 'Buscar geocerca o dispositivo'],
			button: 'CONSULTAR',
			pager: ['Páginas', ' de ', 'filas por páginas', 'elementos'],
			errors: {
				geofence: 'Seleccione al menos una geocerca',
				device: 'Seleccione al menos un dispositivo',
				date: 'Seleccione una fecha valida'
			}
		},
		feedback: ['Geocerca Circular', 'Geocerca Poligonal', 'POI'],
		ifta: {
			title: 'Reporte IFTA',
			subtitles: {
				200: 'Atención',
				204: 'Enviar luego',
				400: 'Error'
			},
			columns: ['Dispositivo', 'Estado', 'Hrs encendido', 'Hrs en reposo', 'Odómetro'],
			buttons: {
				search: 'Consultar',
				download: 'Descargar',
				print: 'Imprimir',
				sure: 'Entendido',
				cancel: 'Cancelar',
				send: 'Enviar luego'
			},
			forms: ['Seleccionar dispositivos', 'Seleccionar mes/año', 'Correos eletrónicos'],
			notifications: {
				200: 'El reporte no se ha podido generar, intentelo en un momento',
				204: 'Este informe puede tardar unos minutos en generarse y se enviará al correo electrónico registrado para este usuario. Agregue cualquier correo electrónico adicional que le gustaría recibir el informe:',
				400: 'Hubo un error o no hay suficiente información para generar el reporte',
				send: 'El informe se enviará a los correos electrónicos en unos minutos.',
				gral: 'Hay algunos errores, verifique los datos.',
			}
		},
		actions: ['Eliminar Elemento Seleccionado', 'Mostrar/Ocultar Etiquetas', 'Mostrar/Ocultar Geocercas', 'Mostrar/Ocultar POIS'],
		reports: {
			tabs: {
				geofence: 'Reporte de permanencia',
				device: 'Reporte de entrada/salida',
				realtime: 'Realtime',
				ifta: 'IFTA',
			},
			selects: {
				geofence: 'Geocerca(s)',
				device: 'Dispositivo(s)',
				realtime: ''
			},
			columns: {
				device: [
					{
						label: 'Dispositivo',
						img: '',
						width: ''
					},
					{
						label: 'Geocerca',
						img: '',
						width: '24%'
					},
					{
						label: 'Entrada',
						img: 'geofences/geo-1.svg',
						width: '16%'
					},
					{
						label: 'Salida',
						img: 'geofences/geo-2.svg',
						width: '16%'
					},
					{
						label: 'Duración',
						img: '',
						width: '12%'
					},
					{
						label: 'Recorrido',
						img: '',
						width: '10%'
					},
				],
				geofence: [
					{
						label: 'Geocerca',
						img: '',
						width: '24%'
					},
					{
						label: 'Dispositivos',
						img: '',
						width: ''
					},
					{
						label: 'Hrs encendido',
						img: '',
						width: '12%'
					},
					{
						label: 'Hrs en reposo',
						img: '',
						width: '12%'
					},
					{
						label: 'Odómetro',
						img: '',
						width: '10%'
					},
				],
				realtime: [
					{
						label: 'Geocerca',
						img: '',
						width: '50%'
					},
					{
						label: 'Dispositivos',
						img: '',
						width: '50%'
					},
				]
			},
			nodata: {
				geofence: 'Sin dispositivos',
				device: 'Sin geocercas'
			},
			notes: {
				retroactive: 'Los reportes no son retroactivos',
			},
		}
	}
};
